import React from "react";
import {SuggestibleRouteInterface} from "./TopRoutes";
const MessageCentre = React.lazy(() => import("../Pages/MessageCentre/MessageCentre"));

const MessageCentreRoutes: Array<SuggestibleRouteInterface> = [
    {
        title: 'Message Centre',
        path: '/message-centre',
        element:
            <React.Suspense fallback={<>...</>}>
                <MessageCentre />
            </React.Suspense>
    },
    {
        title: 'Message Thread',
        path: '/message-centre/:messageId',
        element:
            <React.Suspense fallback={<>...</>}>
                <MessageCentre />
            </React.Suspense>
    },
]

export default MessageCentreRoutes
